import { BinderSmall } from "./binder.model";

export interface SigRequest {
    binderId: number,
    inPerson: boolean,
    embedded_signing_enabled: boolean,
    use_signer_order: boolean,
    files: SignatureRquestFile[],
    signers: BinderPeople[],
    recipients: {
        name: string,
        email: string
    }[] | []
}

interface SignatureRquestFile {
    name: string,
    path: string
}

export class SigResult {
    session?: SigSession;
    eversignResponse: XodoResult;
    constructor() {
        this.eversignResponse = new XodoResult();
    }
}

export interface SigError {
    success: boolean;
    error: {
        code: number;
        type: string;
        info: string;
    };
}

export interface BinderPeople {
    email: string,
    firstName: string,
    lastName: string,
    name: string,
    displayName: string,
    mailing_address: string,
    id: number,
    order: number,
    phones: 
        {
            int: string,
            number: string,
            primary?: boolean
          }[],
    request: boolean,
    role: string,
    clientId: number
}

export class XodoResult {
        success?: boolean;
    error?: {
        code: number;
        type: string;
        info: string;
    };
    document_hash: string;
    requester_email: string;
    custom_requester_name: string;
    custom_requester_email: string;
    is_draft: number;
    is_template: number;
    is_completed: number;
    is_archived: number;
    is_deleted: number;
    is_trashed: number;
    is_cancelled: number;
    embedded: number;
    in_person: number;
    permission: string;
    template_id: string;
    title: string;
    message: string;
    use_signer_order: number;
    reminders: number;
    require_all_signers: number;
    redirect: string;
    redirect_decline: string;
    client: string;
    created: number;
    completed: number;
    expires: number;
    embedded_signing_enabled: number;
    flexible_signing: number;
    files: File[];
    signers: Signer[];
    recipients: Recipient[];
    fields: Field[][];
    log: LogEntry[];
    meta: Meta;

    constructor() {
        this.document_hash = '';
        this.requester_email = '';
        this.custom_requester_name = '';
        this.custom_requester_email = '';
        this.is_draft = 0;
        this.is_template = 0;
        this.is_completed = 0;
        this.is_archived = 0;
        this.is_deleted = 0;
        this.is_trashed = 0;
        this.is_cancelled = 0;
        this.embedded = 0;
        this.in_person = 0;
        this.permission = '';
        this.template_id = '';
        this.title = '';
        this.message = '';
        this.use_signer_order = 0;
        this.reminders = 0;
        this.require_all_signers = 0;
        this.redirect = '';
        this.redirect_decline = '';
        this.client = '';
        this.created = 0;
        this.completed = 0;
        this.expires = 0;
        this.embedded_signing_enabled = 0;
        this.flexible_signing = 0;
        this.files = [];
        this.signers = [];
        this.recipients = [];
        this.fields = [];
        this.log = [];
        this.meta = {};
    }
}

interface File {
    name: string;
    file_id: string;
    pages: number;
}

export interface Signer {
    id: number;
    name: string;
    email: string;
    role: string;
    order: number;
    pin: string;
    signer_authentication_sms_enabled: number;
    signer_authentication_phone_number: string;
    message: string;
    signed: number;
    signed_timestamp: string;
    required: number;
    deliver_email: string;
    language: string;
    declined: number;
    removed: number;
    bounced: number;
    sent: number;
    viewed: number;
    status: string;
}

interface Recipient {
    name: string;
    email: string;
    role: string;
    message: string;
    required: number;
    language: string;
}

interface Field {
    merge: number;
    identifier: string;
    name: string;
    options: string;
    group: string;
    value: string;
    type: string;
    x: number;
    y: number;
    page: number;
    width: number;
    height: number;
    signer: number;
    validation_type: string;
    required: number;
    readonly: number;
    text_size: string;
    text_color: string;
    text_style: string;
    text_font: string;
    files: string;
}

export interface LogEntry {
    event: string;
    signer: string | number;
    timestamp: number;
}

interface Meta {
    [key: string]: string;
}

export interface SessionSigner {
    id: number,
    name: string,
    email: string,
    role: string,
    order: number,
    pin: number,
    signed: number,
    signed_timestamp: number,
    required: number,
    deliver_email: number,
    language: string,
    declined: number,
    removed: number,
    bounced: number,
    sent: number,
    viewed: number,
    embedded_signing_url: string,
    status: string
}

export interface SigRequest {
    binderId: number,
    inPerson: boolean,
    embedded_signing_enabled: boolean,
    use_signer_order: boolean,
    files: SignatureRquestFile[],
    signers: BinderPeople[],
    recipients: {
        name: string,
        email: string
    }[] | []
}

interface SignatureRquestFile {
    name: string,
    path: string
}

export interface SigResult {
    session?: SigSession;
    eversignResponse: XodoResult;
}

export interface BinderPeople {
    email: string,
    firstName: string,
    lastName: string,
    name: string,
    mode: string,
    displayName: string,
    mailing_address: string,
    deliver_email: boolean,
    id: number,
    order: number,
    phones: 
        {
            int: string,
            number: string,
            primary?: boolean
          }[],
    request: boolean,
    role: string,
    clientId: number
}

export class SigSession {
            created: Date; 
            Payload?: {
                document_hash: string,
                requester_email: string,
                custom_requester_name: string,
                custom_requester_email: string,
                is_draft: number,
                is_template: number,
                is_completed: number,
                is_archived: number,
                is_deleted: number,
                is_trashed: number,
                is_cancelled: number,
                is_expired: number,
                embedded: number,
                in_person: number,
                embedded_signing_enabled: number,
                flexible_signing: number,
                title: string,
                subject: string,
                message: string,
                use_signer_order: number,
                reminders: number,
                require_all_signers: number,
                created: number,
                expires: number,
                files: [
                    {
                        name: string,
                        file_id: string,
                        pages: number
                    }
                ],
                signers: SessionSigner[],
                log: [
                    {
                        event: string,
                        signer: number,
                        timestamp: number
                    }
                ]
            };
            BinderID: number | null;
            consultant: number | null;
            sigSessionId: number | null;
            Binders?: BinderSmall;

            constructor(){
                this.created = new Date();
                this.BinderID = null;
                this.consultant = null;
                this.sigSessionId = null;
            }
        }


